import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { FileMetadataService } from 'projects/aumico-project-reports/src/app/microservices/ms-annual-reports/services/documents.service';
import { HttpClient } from '@angular/common/http';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { FileMetadataDto } from 'projects/aumico-project-reports/src/app/microservices/ms-annual-reports/financial-closing-process/dto/file-metadata.dto';
import { FilePreviewStatus } from '@modeso/aumico-lib-cpmm-fe/enums/FilePreviewStatus.enum';

@Injectable({
    providedIn: 'root',
})
export class ComplementaryReportFilesService extends FileMetadataService {
    private readonly uploadFcpDocument = 'upload';
    private readonly encrypt = 'encrypt';

    constructor(
        protected override readonly http: HttpClient,
        protected override readonly coreProvider: AumicoCoreProvider,
    ) {
        super(http, coreProvider);
    }

    uploadComplementaryReportFile$(documentFile: FormData): Observable<FileMetadataDto> {
        const url = `${this.apiGatewayUrl}${this.fileMetadata}/${this.uploadFcpDocument}/${this.encrypt}`;
        this.coreProvider.dispatchBlockingRequest('uploadComplementaryReportFile$');

        return this.http
            .patch<FileMetadataDto>(url, documentFile)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('uploadComplementaryReportFile$')));
    }
    /**
     * Preview: check current generation status for a file.
     */
    getPreviewStatus(fileId: string): Observable<{ status: FilePreviewStatus }> {
        const url = `${this.apiGatewayUrl}file-preview/status/${fileId}?_=${new Date().getTime()}`;
        return this.http.get<{ status: FilePreviewStatus }>(url);
    }

    /**
     * Preview: request generation of a preview for a file.
     */
    requestPreviewGeneration(fileId: string): Observable<{ requestId: string }> {
        const url = `${this.apiGatewayUrl}file-preview/generate/${fileId}`;
        return this.http.post<{ requestId: string }>(url, {});
    }

    /**
     * Preview: fetch generated preview URL for a file.
     */
    getPreview(fileId: string): Observable<{ url: string }> {
        const url = `${this.apiGatewayUrl}file-preview/${fileId}`;
        return this.http.get<{ url: string }>(url);
    }

    /**
     * Fetches the content of a file as a Blob.
     */
    getFileContent(fileId: string): Observable<Blob> {
        const url = `${this.apiGatewayUrl}file-metadata/${fileId}/content`;
        this.coreProvider.dispatchBlockingRequest('getFileContent');
        return this.http
            .get(url, { responseType: 'blob' })
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('getFileContent')));
    }
}
